module.exports = __webpack_public_path__ + "static/media/cover-home-3.d28a3d7e.jpg";